import React from "react";
import { Navigate } from "react-router-dom";
import { usePersistedStore } from "../store/persisted-store";

export default function PrivateRoute({ children }) {
  const { auth } = usePersistedStore();
  const userToken = auth.userToken;

  if (!userToken) {
    // Redirect to new auth flow
    window.location.href = `${window.location.origin}/auth/login?returnUrl=${window.location.pathname}`;
    return null;
  }

  return userToken ? children : <Navigate to="/auth/login" replace />;
}
